<template>
  <div>
    <q-dialog :visible.sync="dialogVisible" title="下载" width="1000px" :innerScroll="false" @cancel="updateVal" @confirm="confirm" @close="updateVal">
      <!-- // 业务 -->
      <div class="searchForm">
        <el-input placeholder="请输入文件夹名字进行搜索" v-model.trim="value" clearable class="cusSearch">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <el-button slot="append" @click="onSearch">搜索</el-button>
        </el-input>
      </div>
      <div class="treebox">
        <div class="left">
          <el-tree
            ref="leftTree"
            class="sheet-tree"
            node-key="id"
            show-checkbox
            :data="leftTreeData"
            :props="defaultProps"
            :icon-class="`el-icon-folder`"
            :expand-on-click-node="clickType"
            :default-expanded-keys="expandedKeys"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            @node-expand="handleNodeExpand"
            @node-collapse="handleNodeCollapse"
            @check-change="handleLeftCheckChange"
          >
            <span class="my-custom" slot-scope="{ node, data }">
              <template>
                <svg class="icon svg-icon" aria-hidden="true" v-show="!node.expanded">
                  <use xlink:href="#icon-folder"></use>
                </svg>
                <svg class="icon svg-icon" aria-hidden="true" v-show="node.expanded">
                  <use xlink:href="#icon-opened_folder"></use>
                </svg>
              </template>
              <span v-if="!data.editable">{{ data.folderName }}</span>
              <input v-model="data.folderName" v-else />
            </span>
          </el-tree>
        </div>
        <div class="center">
          <div>
            <div class="el-icon-right"></div>
            <div>已选({{checkedNodeNumer}})</div>
          </div>
        </div>
        <div class="right">
          <el-tree
            ref="rightTree"
            class="sheet-tree"
            node-key="id"
            default-expand-all
            show-checkbox
            check-strictly
            :data="rightTreeData"
            :props="defaultPropsRight"
            :icon-class="`el-icon-folder`"
            :expand-on-click-node="clickType"
            :default-expanded-keys="expandedKeysSelect"
            @node-expand="handleNodeExpandSelect"
            @node-collapse="handleNodeCollapseSelect"
            @check-change="handleRightCheckChange"
            @check="checkType = true"
          >
            <span class="my-custom" slot-scope="{ node, data }">
              <template>
                <svg class="icon svg-icon" aria-hidden="true" v-show="!node.expanded">
                  <use xlink:href="#icon-folder"></use>
                </svg>
                <svg class="icon svg-icon" aria-hidden="true" v-show="node.expanded">
                  <use xlink:href="#icon-opened_folder"></use>
                </svg>
              </template>
              <span v-if="!data.editable">{{ data.folderName }}</span>
              <input v-model="data.folderName" v-else />
            </span>
          </el-tree>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import { set } from "vue";
export default {
  model: {
    prop: "visible",
    event: "input",
  },
  props: ["visible", "modulesConfig", "leftTreeData", "processType"],
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "folderName",
      },
      defaultPropsRight: {
        children: "children",
        label: "folderName",
        disabled: 'ceshi'
      },
      // leftTreeData: [],
      rightTreeData: [],
      operateStatus: "", // ‘1’ 新增 ‘2’ 编辑
      expandedKeys: [],
      expandedKeysSelect: [],
      serchDataId: [],
      clickType: true,
      folderName: "",
      value: "",
      checkType: false,
      rightNodeMapToLeftNode: new Map(),
      
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    fristNodeIdList() {
      return this.leftTreeData.map(v=>v.id)
    },
    checkedNodeNumer() {
      let nodeOne = this.rightTreeData && this.rightTreeData[0] ? this.rightTreeData[0].folderName != '旧' ? this.rightTreeData[0].children.length : this.lengthNum(this.rightTreeData[0].children) : 0
      let nodeTwo = this.rightTreeData && this.rightTreeData[1] ? this.rightTreeData[1].folderName != '旧' ? this.rightTreeData[1].children.length : this.lengthNum(this.rightTreeData[1].children) : 0
      return nodeOne + nodeTwo
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    lengthNum(arr) {
      if(!arr || !arr.length) return 0
      let sum = 0
      arr.forEach(v=>{
        sum += v.children ? v.children.length : 0
      })
      return sum
    },
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit("success");
      }
      this.$emit("close");
    },
    confirm() {
      if(this.isFirstCheck() && this.checkedNodeNumer > 10) {
        this.$message.error('不允许直接选择顶层文件夹进行下载！')
        return
      }else if(!this.rightTreeData.length) {
        this.$message.error('请至少选择一个文件夹！')
        return
      }else if(this.checkedNodeNumer > 10) {
        this.$message.error('一次最多下载10个文件夹！')
        return
      }
      let _this = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$q.newProduct.pictureDownloadBatch({ data: {nodeList: this.rightTreeData, processType: this.processType }}).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if(res.data.taskStatus == '执行完成') {
                clearInterval(timer)
                if(res.data.taskResult == '成功') {
                  _this.downloadRes(res.data.filePath, res.data.taskDesc);
                  // _this.$message.success('下载成功');
                  _this.updateVal();
                }else{
                  _this.updateVal()
                  _this.$message.error(res.data.failReason);
                }
                loading.close()
              }
            })
            .catch((err) => {
              loading.close()
              // this.$message.error(err.message);
            });
        }, 5000);
      }).catch(() => {
        loading.close()
      });
      
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },
    isFirstCheck() {
      let checkedKeys = this.$refs.leftTree.getCheckedKeys();
      let work = this.$refs.leftTree.getCheckedNodes();
      console.log(work)
      var errorType = false
      this.fristNodeIdList.forEach(v=>{
        if(checkedKeys.includes(v)){
          errorType = true
        }
      })
      return errorType
    },
    onSearch() {
      this.serchDataId = [];
      if(!this.value) {
        this.$refs.leftTree.filter(false)
      }else if(this.value.length > 4) {
        this.$refs.leftTree.filter(this.value);
      }
    },
    init() {
      // return this.$q.newProduct.pictureTreeMenus().then((res) => {
      //   this.leftTreeData = res.data;
      //   // 默认展开根目录
      //   // this.expandedKeys.indexOf(this.sheetData[0].id) === -1 && this.expandedKeys.push(this.sheetData[0].id);
      // });
    },
    handleNodeClick(data) {
      // console.log(data);
    },
    // 节点展开
    handleNodeExpand(data, node, $el) {
      this.expandedKeys.push(data.id);
    },
    // 节点展开
    handleNodeExpandSelect(data, node, $el) {
      this.expandedKeysSelect.push(data.id);
    },
    // 节点折叠
    handleNodeCollapse(data, node, $el) {
      this.expandedKeys = this.expandedKeys.filter((v) => v != data.id);
      if (data.children && data.children.length) {
        let childrenDataId = this.tree2flat(data.children).map((v) => v.id);
        this.expandedKeys = this.expandedKeys.filter((v) => !childrenDataId.includes(v));
      }
    },
    // 节点折叠
    handleNodeCollapseSelect(data, node, $el) {
      this.expandedKeysSelect = this.expandedKeysSelect.filter((v) => v != data.id);
      if (data.children && data.children.length) {
        let childrenDataId = this.tree2flat(data.children).map((v) => v.id);
        this.expandedKeysSelect = this.expandedKeysSelect.filter((v) => !childrenDataId.includes(v));
      }
    },
    //过滤保留子节点
    filterNode(value,data,node) {
      if(!value){
        node.expanded = false;
        return true;
      }
      let _array = [];
      this.getReturnNode(node,_array,value);
      let result = false;
      _array.forEach((item)=>{
        result = result || item;
      });
      return result;
    },
    getReturnNode(node,_array,value){
      let isPass = node.data &&  node.data.folderName && node.data.folderName.indexOf(value) !== -1;
      isPass?_array.push(isPass):'';
      this.index++;
      if(!isPass && node.level!=1 && node.parent){
        this.getReturnNode(node.parent,_array,value);
      }
    },
    
    handleLeftCheckChange(node, checked) {
      if(this.checkType) return
      // this.checkedNodeNumer = this.$refs.leftTree.getCheckedNodes(true).length || 0
      const checkedNodes = this.$refs.leftTree.getCheckedNodes(false, true);
      const copyNodes = JSON.parse(JSON.stringify(checkedNodes));
      // console.log(copyNodes);
      this.$nextTick(_=>{
        this.$refs.rightTree.setCheckedNodes(copyNodes)
      })
      if(!copyNodes.length && this.rightTreeData.length) {
        this.$refs.rightTree.remove(this.rightTreeData[0].id)
        return
      }
      copyNodes.forEach((x) => {
        x.children = [];
        if (!this.$refs.rightTree.getNode(x.id)) {
          this.$refs.rightTree.append(x, x.parentId === null ? "" : x.parentId);
        }
      });
      if (!checked) {
        this.$refs.rightTree.remove(node, node.id);
        this.deleteEmptyParentNode(node);
      }
    },
    deleteEmptyParentNode(node) {
      if (!node.parentId) return;
      if (this.$refs.rightTree.getNode(node.parentId)) {
        if (!this.$refs.rightTree.getNode(node.parentId).childNodes.length) {
          let grandpaNodeId = this.$refs.rightTree.getNode(node.parentId).data.parentId  //获取上层的父级id
          //判断当前删除节点父级的父级是否子集已经全部删除
          if(grandpaNodeId && (!this.$refs.rightTree.getNode(grandpaNodeId).childNodes.length || this.$refs.rightTree.getNode(grandpaNodeId).childNodes.length == 1)){
            let fristNodeId = this.$refs.rightTree.getNode(grandpaNodeId).data.parentId
            this.$refs.rightTree.remove(grandpaNodeId);
            //判断顶级节点下是否子节点全部删除
            if(fristNodeId && !this.$refs.rightTree.getNode(fristNodeId).childNodes.length) {
              this.$refs.rightTree.remove(fristNodeId);
            }
          }else if(this.$refs.rightTree.getNode(node.parentId)) {
            this.$refs.rightTree.remove(this.$refs.rightTree.getNode(node.parentId), this.$refs.rightTree.getNode(node.parentId).childNodes.id);
          }
        }
      }
    },
    handleRightCheckChange(node, checked) {
      // console.log(this.rightTreeData)
      setTimeout(() => {
        if (!checked && this.checkType) {
          this.$nextTick((_) => {
            this.$refs.rightTree.remove(node,node.id);
            this.deleteEmptyParentNode(node);
            this.$refs.leftTree.setChecked(node, false,true);
            // this.checkedNodeNumer = this.$refs.leftTree.getCheckedNodes(true).length || 0
            setTimeout(() => {
              const checkedNodes = this.$refs.leftTree.getCheckedNodes(false, true);
              if(!checkedNodes.length && this.rightTreeData.length) {
                this.$refs.rightTree.remove(this.rightTreeData[0].id)
              }
              this.checkType = false;
            }, 50);
          });
        }
      }, 50);
    },
    // tree数据转平级
    tree2flat(source) {
      let res = [];
      const fn = (source) => {
        source.forEach((el) => {
          res.push(el);
          el.children && el.children.length > 0 ? fn(el.children) : "";
        });
      };
      fn(source);
      return res;
    },
  },
};
</script>

<style lang="stylus" scoped>
.searchForm {
  width: 300px;
  margin-bottom: 10px;
}

>>> .cusSearch .el-input__suffix {
  display: flex !important;
  align-items: center !important;
}

>>> .cusSearch .el-input__inner {
  background: #f6f8fa !important;
  font-size: 12px;
  height: 30px;
}

>>> .cusSearch .el-input-group__append .el-button {
  position: relative;
  top: -1.5px;
  font-size: 12px;
  background: #0bb78e;
  color: #ffffff;
  height: 30px;
  border-radius: 0px 4px 4px 0px;
}

>>> .el-dialog {
  margin-top: 50px !important;
}

.treebox {
  width: 100%;
  display: flex
    .left {
      padding: 10px 0px;
      width: 45%;
      height: 70vh;
      overflow-y: auto;
      background: #F6FAFA;
      border-radius: 6px;
    }

    .center {
      display: flex;
      height: 70vh;
      width: 10%
      justify-content: center
      text-align: center
      align-items: center;
      flex-wrap: wrap
      color: #22BA8E
    }

    .right {
      padding: 10px 0px;
      width: 45%;
      height: 70vh;
      overflow-y: auto;
      background: #F6FAFA;
      border-radius: 6px;
    }
}

>>> .el-icon-right{
  font-size: 28px
}

>>> .el-tree-node__expand-icon {
  display: block;
  position: relative;
  left: -500px !important;
}

>>> .el-tree-node__content {
  width: 100%;
  box-sizing: border-box;
}

.sheet-tree {
  position: reletive;
  background: #F6FAFA;
}

.my-custom {
  width: 100%;
  display: inline-block;
  padding-right: 36px;
  // user-select none
  position: relative;
}

.node-operate {
  position: absolute;
  right: 15px;
  top: 1px;
  width: 120px;
}

.el-icon-star-on {
  font-size: 18.5px;
  position: absolute;
  top: 1px;
  right: 0;
  color: rgb(255, 160, 0);
}

.el-icon-star-off {
  font-size: 15px;
  position: absolute;
  top: 1px;
  right: 0;
  color: #999;
}

.edit-icons {
  span {
    display: inline-block;
    font-size: 16px;
    position: absolute;
    right: 120px;
  }

  .el-icon-circle-plus-outline {
    color: rgb(31, 173, 128);
    right: 0;
  }

  .el-icon-edit {
    color: rgb(250, 153, 87);
    right: 30px;
  }

  .el-icon-delete {
    color: rgb(227, 122, 112);
    right: 60px;
  }

  .el-icon-check {
    color: rgb(31, 173, 128);
    right: 90px;
  }

  .el-icon-close::before {
    color: rgb(227, 122, 112) !important;
  }
}

.icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  overflow: hidden;
  position: relative;
  top: -1px;
}
</style>
